import { render } from "./singleMarket.vue?vue&type=template&id=59d31fa4"
import script from "./singleMarket.vue?vue&type=script&lang=js"
export * from "./singleMarket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__